module.exports = __webpack_public_path__ + "img/Desktop-Loading.8115d581.png";